<!--  Contenido de Eventos y Activator  -->
@if (eventForm && activatorForm) {
<div class="flow-content-wrapper">
  <form class="st-form" nz-form [formGroup]="eventForm">
    <div nz-row [nzGutter]="16">
      <!-- Icono -->
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label nzRequired [nzSpan]="24">Icono</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'">
            <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                       [formControlName]="'icon'"
                       nzPlaceHolder="Selecciona el Icono..." [nzDropdownStyle]="{width: '315px'}"
                       nzDropdownClassName="grid-dropdown" [nzOptionOverflowSize]="300"
                       [nzDropdownMatchSelectWidth]="false" [nzCustomTemplate]="iconSelectTpmpl">
              @for (icon of iconsList; track icon) {
                <nz-option [nzLabel]="icon" [nzValue]="icon" nzCustomContent>
                  <button nz-button nzShape="circle" class="text-btn-16 flex-center" nzType="text" style="color: inherit">
                    <app-st-icon [name]="icon"></app-st-icon>
                  </button>
                </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Color -->
      <div nz-col [nzSpan]="12">
        <nz-form-item>
          <nz-form-label nzRequired [nzSpan]="24">Color</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'">
            <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                       [formControlName]="'color'"
                       nzPlaceHolder="Selecciona el Color..." [nzDropdownStyle]="{width: '184px'}"
                       nzDropdownClassName="grid-dropdown" [nzOptionOverflowSize]="43"
                       [nzDropdownMatchSelectWidth]="false" [nzCustomTemplate]="colorSelectTpmpl">
              @for (color of colorList; track color) {
                <nz-option [nzLabel]="color" [nzValue]="color" nzCustomContent>
                  <button nz-button nzShape="circle" class="text-btn-16 flex-center" nzType="text">
                    <app-st-icon [color]="color" [filled]="true" name="fiber_manual_record"></app-st-icon>
                  </button>
                </nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label [nzSpan]="24" nzRequired>Evento</nz-form-label>
      <nz-form-control [nzErrorTip]="'Este campo es requerido'">
        <input type="text" nzSize="large" nz-input formControlName="name"
               placeholder="Introduce Nombre del Evento..." />
      </nz-form-control>
    </nz-form-item>
  </form>
  <form style="padding-top: 0" class="st-form" nz-form [formGroup]="activatorForm">
    <div nz-row [nzGutter]="8">
      <!-- Activador -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label nzRequired [nzSpan]="24">Activador</nz-form-label>
          <nz-form-control [nzErrorTip]="'Este campo es requerido'">
            <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                       (ngModelChange)="!isUpdating ? changeActivator() : null"
                       formControlName="name" nzPlaceHolder="Selecciona el Activador...">
              @for (activador of activadorNameList; track activador) {
                <nz-option [nzLabel]="activador" [nzValue]="activador"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>

      <!-- Select de documentos -->
      @if (activatorForm.get('name')?.value === 'Subida documento' || activatorForm.get('name')?.value === 'Validacion documento') {
        <div
             nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24"></nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                         (ngModelChange)="!isUpdating ? updateEventForm() : null"
                         formControlName="value" nzPlaceHolder="Selecciona el Tipo de Documento...">
                @for (doc of documentTypes; track doc) {
                  <nz-option [nzLabel]="doc.name" [nzValue]="doc.id"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      }

      <!-- Select de estados de Mojito360 -->
      @if (activatorForm.get('name')?.value === 'Fecha Mojito') {
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24"></nz-form-label>
            <nz-form-control [nzErrorTip]="'Este campo es requerido'">
              <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large" nzShowSearch
                         (ngModelChange)="!isUpdating ? updateEventForm() : null"
                         formControlName="value" nzPlaceHolder="Selecciona el Estado...">
                @for (estado of estadosMojito; track estado) {
                  <nz-option [nzLabel]="estado" [nzValue]="estado"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      }

      <!-- Select de lugares -->
      @if (activatorForm.get('name')?.value === 'Manual') {
        <div nz-col [nzXs]="24" [nzSm]="12">
          <nz-form-item>
            <nz-form-label [nzSpan]="24">Lugar</nz-form-label>
            <nz-form-control>
              <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                         (ngModelChange)="!isUpdating ? updateEventForm() : null" nzShowSearch nzAllowClear
                         [compareWith]="compareById"
                         formControlName="location" nzPlaceHolder="Selecciona el Lugar...">
                @for (location of locations; track location) {
                  <nz-option [nzLabel]="location.name" [nzValue]="location"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      }
    </div>

    <div nz-row [nzGutter]="8">
      <!-- Select de lugares -->
      <div nz-col [nzXs]="24" [nzSm]="12">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Estado Mojito360</nz-form-label>
          <nz-form-control>
            <nz-select [nzClearIcon]="customClearIcon" [nzSuffixIcon]="customSelectIcon" nzSize="large"
                       (ngModelChange)="!isUpdating ? updateEventForm() : null" nzShowSearch nzAllowClear
                       [compareWith]="compareByEnum"
                       formControlName="mojitoDynamicField" nzPlaceHolder="Selecciona el Campo...">
              @for (campo of flowEventService.mojitoDynamicFieldOptions; track campo) {
     <nz-option
                [nzLabel]="campo.label" [nzValue]="campo"></nz-option>
              }
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </form>
</div>
}

<ng-template #customSelectIcon>
  <app-st-icon class="custom-suffix" name="keyboard_arrow_down"></app-st-icon>
</ng-template>
<ng-template #customClearIcon>
  <app-st-icon class="custom-clear" name="close"></app-st-icon>
</ng-template>
<ng-template #iconSelectTpmpl let-selected>
  <app-st-icon [name]="selected.nzValue"></app-st-icon>
</ng-template>

<ng-template #colorSelectTpmpl let-selected>
  <app-st-icon [color]="selected.nzValue" [filled]="true" name="fiber_manual_record"></app-st-icon>
</ng-template>
